/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { OWEventTypeResponse } from './OWEventTypeResponse';
import {
    OWEventTypeResponseFromJSON,
    OWEventTypeResponseFromJSONTyped,
    OWEventTypeResponseToJSON,
    OWEventTypeResponseToJSONTyped,
} from './OWEventTypeResponse';

/**
 * 
 * @export
 * @interface GetOverwolfEventTypesResponse
 */
export interface GetOverwolfEventTypesResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetOverwolfEventTypesResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<OWEventTypeResponse>}
     * @memberof GetOverwolfEventTypesResponse
     */
    eventTypes: Array<OWEventTypeResponse>;
}

/**
 * Check if a given object implements the GetOverwolfEventTypesResponse interface.
 */
export function instanceOfGetOverwolfEventTypesResponse(value: object): value is GetOverwolfEventTypesResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('eventTypes' in value) || value['eventTypes'] === undefined) return false;
    return true;
}

export function GetOverwolfEventTypesResponseFromJSON(json: any): GetOverwolfEventTypesResponse {
    return GetOverwolfEventTypesResponseFromJSONTyped(json, false);
}

export function GetOverwolfEventTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOverwolfEventTypesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'eventTypes': ((json['eventTypes'] as Array<any>).map(OWEventTypeResponseFromJSON)),
    };
}

export function GetOverwolfEventTypesResponseToJSON(json: any): GetOverwolfEventTypesResponse {
    return GetOverwolfEventTypesResponseToJSONTyped(json, false);
}

export function GetOverwolfEventTypesResponseToJSONTyped(value?: GetOverwolfEventTypesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'eventTypes': ((value['eventTypes'] as Array<any>).map(OWEventTypeResponseToJSON)),
    };
}

